import type { UseQueryResult } from "react-query";

import { ExecutionStatus } from "features/shared/model/types";
import { useEffect } from "react";

import { EXECUTION_POLL_INTERVAL_MS } from "../../lib/configs";
import { hasInProgressJobs } from "../../lib/processingJob";

export const usePollWhileJobsInProgress = <T extends { status: ExecutionStatus }>(
  query: UseQueryResult<T[], Error>
): void => {
  const { data, refetch } = query;

  useEffect(() => {
    if (!hasInProgressJobs(data)) return;

    const intervalId = setInterval(refetch, EXECUTION_POLL_INTERVAL_MS);

    return () => clearInterval(intervalId);
  }, [data, refetch]);
};
